var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	22307: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,18,2,14], () => (__webpack_require__.e(623).then(() => (() => (__webpack_require__(/*! @angular/core */ 19004))))))),
	67057: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,18,2,14], () => (__webpack_require__.e(572).then(() => (() => (__webpack_require__(/*! @angular/common */ 39191))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(56).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 57056))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(994).then(() => (() => (__webpack_require__(/*! rxjs */ 96994))))))),
	15321: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/event-dispatch", false, [4,18,2,14], () => (__webpack_require__.e(672).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/event-dispatch */ 17672))))))),
	38157: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [4,18,2,14], () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 96346))))))),
	5757: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,18,2,14], () => (__webpack_require__.e(627).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 77008))))))),
	76608: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,18,2,14], () => (__webpack_require__.e(199).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 4199))))))),
	77901: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,18,2,14], () => (__webpack_require__.e(480).then(() => (() => (__webpack_require__(/*! @angular/router */ 41099))))))),
	90410: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [4,3,24,0], () => (__webpack_require__.e(456).then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 82075))))))),
	15094: () => (loadStrictSingletonVersion("default", "primeng/icons/chevronright", false, [4,17,18,9], () => (__webpack_require__.e(169).then(() => (() => (__webpack_require__(/*! primeng/icons/chevronright */ 12169))))))),
	15783: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [4,18,2,14], () => (__webpack_require__.e(15).then(() => (() => (__webpack_require__(/*! @angular/animations */ 12015))))))),
	18418: () => (loadStrictSingletonVersion("default", "primeng/dom", false, [4,17,18,9], () => (__webpack_require__.e(269).then(() => (() => (__webpack_require__(/*! primeng/dom */ 63269))))))),
	39300: () => (loadStrictSingletonVersion("default", "primeng/icons/chevrondown", false, [4,17,18,9], () => (__webpack_require__.e(902).then(() => (() => (__webpack_require__(/*! primeng/icons/chevrondown */ 36521))))))),
	76106: () => (loadStrictSingletonVersion("default", "primeng/utils", false, [4,17,18,9], () => (__webpack_require__.e(114).then(() => (() => (__webpack_require__(/*! primeng/utils */ 7114))))))),
	90538: () => (loadStrictSingletonVersion("default", "primeng/api", false, [4,17,18,9], () => (__webpack_require__.e(986).then(() => (() => (__webpack_require__(/*! primeng/api */ 24605))))))),
	18436: () => (loadStrictSingletonVersion("default", "primeng/baseicon", false, [4,17,18,9], () => (__webpack_require__.e(164).then(() => (() => (__webpack_require__(/*! primeng/baseicon */ 57783))))))),
	15989: () => (loadStrictSingletonVersion("default", "@angular-architects/module-federation", false, [4,18,0,4], () => (__webpack_require__.e(103).then(() => (() => (__webpack_require__(/*! @angular-architects/module-federation */ 61484))))))),
	44634: () => (loadStrictSingletonVersion("default", "primeng/accordion", false, [4,17,18,9], () => (__webpack_require__.e(244).then(() => (() => (__webpack_require__(/*! primeng/accordion */ 52863))))))),
	59247: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,18,2,14], () => (__webpack_require__.e(634).then(() => (() => (__webpack_require__(/*! @angular/forms */ 48015))))))),
	83731: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [4,3,0,24], () => (__webpack_require__.e(877).then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 76258))))))),
	94123: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,18,2,14], () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 48065)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"8": [
		22307,
		32778,
		44866,
		67057
	],
	"9": [
		5757,
		15783,
		15989,
		22307,
		32778,
		44634,
		44866,
		59247,
		67057,
		76608,
		77901,
		83731,
		90410,
		94123
	],
	"65": [
		22307,
		32778,
		44866
	],
	"99": [
		22307,
		32778,
		44866,
		67057,
		76608
	],
	"164": [
		76106
	],
	"169": [
		18436
	],
	"191": [
		22307
	],
	"199": [
		5757
	],
	"244": [
		15094,
		18418,
		39300,
		76106,
		90538
	],
	"253": [
		22307,
		32778,
		44866,
		67057
	],
	"258": [
		22307,
		32778,
		44866,
		67057,
		77901,
		90410
	],
	"396": [
		22307,
		67057
	],
	"446": [
		32778
	],
	"480": [
		32778,
		44866,
		67057,
		76608
	],
	"521": [
		18436,
		22307
	],
	"550": [
		18436,
		22307
	],
	"580": [
		5757,
		22307,
		67057
	],
	"605": [
		22307,
		44866,
		76106
	],
	"623": [
		15321,
		32778,
		38157,
		44866
	],
	"627": [
		32778,
		44866
	],
	"634": [
		32778
	],
	"783": [
		22307,
		76106
	],
	"863": [
		15094,
		15783,
		18418,
		22307,
		39300,
		67057,
		76106,
		90538
	],
	"877": [
		32778,
		77901,
		90410
	],
	"902": [
		18436
	],
	"986": [
		44866
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}